import * as MeteringSystemAction from './action';
const initialState = {
    downloadTemplate: [],
    downloadTemplateFailure: [],
    downloadExcelFileSuccess:[],
    meteringSystem: [],
    meteringSystemError: [],
    meteringSystemExcelDownload: [],
    meteringSystemExcelDownloadError: [],
    meteringSystemPagination:{},
    meteringSystemTotalPages:null,
    excelUploadMeteringSystemSuccess:[],
    excelUploadMeteringSystemFailure:[],
    mailConfig: null,
    mailConfigError: null,
    saveMailConfigSuccess: null,
    saveMailConfigFailure: null,
    checkAgreementStatusSuccess: null,
    checkAgreementStatusFailure: null,
    notifySalesAssociateSuccess: null,
    notifySalesAssociateFailure: null
}
    
const MeteringSystemReducer = (state = initialState, action) => {
    switch (action.type) {
        case MeteringSystemAction.DOWNLOAD_EXCEL_FILE:
            return state = {
                ...state,
                downloadTemplate: action.data
            }
        case MeteringSystemAction.DOWNLOAD_EXCEL_FILE_SUCCESS:
            return state = {
                ...state,
                downloadExcelFileSuccess: action.data
            }
        case MeteringSystemAction.DOWNLOAD_EXCEL_FILE_FAILURE:
            return state = {
                      ...state,
                      downloadTemplateFailure: action.data
                  }    
            
        case MeteringSystemAction.METERING_SYSTEM_DATA_SUCCESS:
            return state = {
                        ...state,
                        meteringSystem: action.data.response.content,
                        meteringSystemPagination:action.data.response.pageable,
                        meteringSystemTotalPages:action.data.response.totalPages,
                    }
        case MeteringSystemAction.METERING_SYSTEM_DATA_FAILURE:
            return state = {
                        ...state,
                        meteringSystemError: action.error
                    }
        case MeteringSystemAction.METERING_SYSTEM_EXCEL_DOWNLOAD_SUCCESS:
            return state = {
                        ...state,
                        meteringSystemExcelDownload: action.data
                    }
        case MeteringSystemAction.METERING_SYSTEM_EXCEL_DOWNLOAD_FAILURE:
            return state = {
                        ...state,
                        meteringSystemExcelDownloadError: action.error
                    }
        case MeteringSystemAction.UPLOAD_METERING_SYSTEM_SUCCESS:
            return state = {
                        ...state,
                        excelUploadMeteringSystemSuccess:action.data
                    }  
        case MeteringSystemAction.UPLOAD_METERING_SYSTEM_FAILURE:
            return state = {
                        ...state,
                        excelUploadMeteringSystemFailure:action.data
                    }
        case MeteringSystemAction.FETCH_MAIL_CONFIG:
            return {
                ...state,
                mailConfig: null,
                mailConfigError: null,
                saveMailConfigSuccess: null,
                saveMailConfigFailure: null
            }
        case MeteringSystemAction.FETCH_MAIL_CONFIG_SUCCESS:
            return {
                ...state,
                mailConfig: action.data,
                mailConfigError: null
            }
        case MeteringSystemAction.FETCH_MAIL_CONFIG_FAILURE:
            return {
                ...state,
                mailConfig: null,
                mailConfigError: action.data
            }
        case MeteringSystemAction.SAVE_MAIL_CONFIG_SUCCESS:
            return {
                ...state,
                mailConfig: action.data,
                saveMailConfigSuccess: action.data,
                saveMailConfigFailure: null
            }
        case MeteringSystemAction.SAVE_MAIL_CONFIG_FAILURE:
            return {
                ...state,
                saveMailConfigFailure: action.data,
                saveMailConfigSuccess: null
            }
        case MeteringSystemAction.CHECK_AGREEMENT_STATUS_SUCCESS:
            return {
                ...state,
                checkAgreementStatusSuccess: action.data,
                checkAgreementStatusFailure: null
            }
        case MeteringSystemAction.CHECK_AGREEMENT_STATUS_FAILURE:
            return {
                ...state,
                checkAgreementStatusFailure: action.data,
                checkAgreementStatusSuccess: null
            }
        case MeteringSystemAction.NOTIFY_SALES_ASSOCIATE_SUCCESS:
            return {
                ...state,
                notifySalesAssociateSuccess: action.data,
                notifySalesAssociateFailure: null
            }
        case MeteringSystemAction.NOTIFY_SALES_ASSOCIATE_FAILURE:
            return {
                ...state,
                notifySalesAssociateFailure: action.data,
                notifySalesAssociateSuccess: null
            }
            default: return state;
                
        }
    }
    export default MeteringSystemReducer; 